/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext } from "react";
import { BannerImage, Brush, Container, InfoButton } from "./styles";
import bgBrush from "assets/header-banner/bg-brush-mobile.png";
import infoIcon from "assets/header-banner/info-button.svg";
import { ShopContext } from "pages/StoreFront";
import { ISectionMenuItem } from "../../../../components/PageTopNav/types";
import { getVariantImage } from "helpers/getVariantImage";
import { useMediaQuery } from "@mui/material";
import { useEnvContext, useGoogleAnalyticsContext } from "contexts";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import {
	onOpenPopUp,
	onOpenPopUpV2,
	selectPopUpManagerState
} from "redux/slices";
import { Shine } from "components/PopUpManager/lib/Tutorial/styles";
import { tutorialAssets } from "assets/cdn";
import { FeaturesFlags } from "helpers";

const HeaderBanner = () => {
	const { getImage } = useImagePath("cdn");
	const shine = getImage(tutorialAssets.shine);
	const dispatch = useAppDispatch();
	const sectionMenuData: ISectionMenuItem[] =
		useContext(ShopContext)?.sectionMenuData;
	const { isFeatureFlagEnabled } = useEnvContext();
	const isPortrait = useMediaQuery("(max-width:719px)");
	const { variant } = useAppSelector(selectPopUpManagerState);
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const section = sectionMenuData.find(
		(section) => section.name === "shop_header"
	);

	const handleInfoClick = () => {
		if (variant === "tutorial") {
			return;
		}
		if (isFeatureFlagEnabled(FeaturesFlags.FTUE_V2)) {
			dispatch(
				onOpenPopUpV2({
					variant: "tutorial-v2",
					id: "tutorial-v2",
					replaceIfExists: true
				})
			);
		} else {
			dispatch(onOpenPopUp("tutorial"));
		}
		reportEvent("tutorial", {
			source: "info_button_click"
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "tutorial",
			event_type: "shop_visual_update",
			action: "info_button_click",
			source: "tutorial"
		});
	};

	if (!section) {
		return null;
	}

	return (
		<Container id="tutorial-info-button-container">
			<BannerImage
				src={getVariantImage(
					section?.cardBackgroundImageUrl || "",
					"{shop_header_variant}",
					isPortrait ? "small" : "large"
				)}
			/>
			<Shine
				id="tutorial-info-button-shine"
				src={shine}
				alt="shine effect"
				width={71}
			/>
			<InfoButton
				id="tutorial-info-button"
				src={infoIcon}
				onClick={handleInfoClick}
			/>
			<Brush image={bgBrush}></Brush>
		</Container>
	);
};

export default HeaderBanner;
